// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"Checkbox_checkboxContainer__iuFja","checkbox":"Checkbox_checkbox__Q348_","checkboxLabel":"Checkbox_checkboxLabel__2bpeX"};